import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useState } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Notification from "../notification/Notification";
import { useTranslation } from "react-i18next";
import { stablingCurrencies } from "../../../utils/consts";

const StablingCurrenciesSelect = ({
  checkedCurrencies,
  setCheckedCurrencies
}) => {
  const { t } = useTranslation("otherInterface");

  const currencies = stablingCurrencies;

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const handleChangeSelect = (e) => {
    let data = e.target.value;
    setCheckedCurrencies(data);
  };

  if (Object.keys(currencies).length === 0) {
    return "Empty ProjectsContainer";
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <FormControl>
        <InputLabel id="currencies-simple-select-label">{t("stablingСurrenciesSelect.title")}</InputLabel>
        {/* No need to change on Autocomplete component (few options) */}
        <Select
          labelId="currencies-simple-select-label"
          id="currencies-simple-select"
          value={checkedCurrencies ?? null}
          onChange={handleChangeSelect}
        >
          {currencies.map((currency) => (
            <MenuItem
              key={currency.asset}
              value={currency.asset}
            >
              {t("stablingСurrenciesSelect." + currency.name)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default StablingCurrenciesSelect;